// Roles
export const ROLE_ADMIN = "admin";
export const ROLE_MANAGER = "manager";
export const ROLE_FINANCE = "finance";
export const ROLE_OPERATIONS = "operations";
export const ROLE_EP = "executive_producer";
export const ROLE_PL = "producer_lead";
export const ROLE_PRODUCER = "producer";
export const ROLE_AP = "associate_producer";
export const ROLE_PROJECT_OWNER = "project_owner";
export const ROLE_CLIENT = "client";
export const ROLE_FREELANCE = "freelance";
export const ROLE_OWNER = "owner";

// Permissions
export const PERMISSION_GET_PERSONS = "get_persons";
export const PERMISSION_POST_PERSONS = "post_persons";
export const PERMISSION_EDIT_PERSONS = "edit_persons";
export const PERMISSION_DELETE_PERSONS = "delete_persons";

export const PERMISSION_GET_PROJECTS = "get_projects";
export const PERMISSION_GET_ALL_PROJECTS = "get_all_projects";
export const PERMISSION_POST_PROJECTS = "post_projects";
export const PERMISSION_EDIT_PROJECTS = "edit_projects";
export const PERMISSION_EDIT_ALL_PROJECTS = "edit_all_projects";
export const PERMISSION_DELETE_PROJECTS = "delete_projects";

export const PERMISSION_FROM_PROJECT_STATUS = "from_project_status:";
export const PERMISSION_TO_PROJECT_STATUS = "to_project_status:";

export const PERMISSION_GET_CLIENTS = "get_clients";
export const PERMISSION_POST_CLIENTS = "post_clients";
export const PERMISSION_EDIT_CLIENTS = "edit_clients";
export const PERMISSION_DELETE_CLIENTS = "delete_clients";
export const PERMISSION_EDIT_CLIENT_FORECASTS = "edit_client_forecasts";

export const PERMISSION_POST_FILES = "post_files";
export const PERMISSION_DELETE_FILES = "delete_files";
export const PERMISSION_POST_COMMENTS = "post_comments";
export const PERMISSION_DELETE_COMMENTS = "delete_comments";

export const PERMISSION_GET_INVOICES = "get_invoices";
export const PERMISSION_GET_BILLS = "get_bills";
export const PERMISSION_GET_ALL_BILLS = "get_all_bills";
export const PERMISSION_GET_ALL_BILLS_DASHBOARD = "get_all_bills_dashboard";
export const PERMISSION_POST_BILLS = "post_bills";
export const PERMISSION_EDIT_BILLS = "edit_bills";
export const PERMISSION_EDIT_ALL_BILLS = "edit_all_bills";
export const PERMISSION_DELETE_BILLS = "delete_bills";

export const PERMISSION_GET_BIDS = "get_bids";
export const PERMISSION_GET_ALL_BIDS = "get_all_bids";
export const PERMISSION_GET_ALL_BIDS_DASHBOARD = "get_all_bids_dashboard";
export const PERMISSION_POST_BIDS = "post_bids";
export const PERMISSION_EDIT_BIDS = "edit_bids";
export const PERMISSION_EDIT_ALL_BIDS = "edit_all_bids";
export const PERMISSION_DELETE_BIDS = "delete_bids";
export const PERMISSION_APPROVE_BIDS = "approve_bids";
export const PERMISSION_CREATE_GLOBAL_BID_TEMPLATES =
    "create_global_bid_templates";

export const PERMISSION_GET_PROJECT_TYPES = "get_project_types";
export const PERMISSION_GET_FINANCIAL_TERMS = "get_financial_terms";

export const PERMISSION_GET_LEGAL_ENTITIES = "get_legal_entities";
export const PERMISSION_EDIT_LEGAL_ENTITIES = "edit_legal_entities";
export const PERMISSION_POST_LEGAL_ENTITIES = "post_legal_entities";
export const PERMISSION_DELETE_LEGAL_ENTITIES = "delete_legal_entities";

export const PERMISSION_GET_REPORTS = "get_reports";

export const PERMISSION_VIEW_CONFIDENTIAL_DATA = "view_confidential_data";
export const PERMISSION_VIEW_RESTRICTED_DATA = "view_restricted_data";
export const PERMISSION_VIEW_EXTERNAL_NAV_LINKS = "view_external_nav_links";
export const PERMISSION_VIEW_ADMIN_PANEL = "view_admin_panel";

export const PERMISSION_CONFIRM_REFUTED_ACCOUNTING_BILL =
    "confirm_refuted_accounting_bill";
export const PERMISSION_EDIT_EXCHANGE_RATES = "edit_exchange_rates";
